import React from 'react'
import { Button, Header, Icon, Modal } from 'semantic-ui-react'

const ModalSiNo = ({showModal, closeModal, icono, borrar, texto, titulo}) => (
  <Modal open={showModal} basic size='tiny'>
    <Header icon={icono} content={titulo} />
    <Modal.Content>
      <p>
        {texto}
      </p>
    </Modal.Content>
    <Modal.Actions>
      <Button basic color='red' onClick={closeModal} inverted>
        <Icon name='remove' /> No
      </Button>
      <Button color='green' onClick={borrar} inverted>
        <Icon name='checkmark' /> Si
      </Button>
    </Modal.Actions>
  </Modal>
)

export default ModalSiNo